
import { defineComponent } from "vue";
import DhHeader from "@/components/DhHeader.vue";
import DhTable from "@/components/DhTable.vue";
import DhTableColumn from "@/components/DhTableColumn.vue";
import DhButton from "@/components/DhButton.vue";
import { useRemoteList } from "@/hooks/useRemoteList";
import { products } from "@/api";
import {useExportToCsv} from "@/hooks/useExportToCsv";

export default defineComponent({
  name: "Product",
  components: {
    DhButton,
    DhHeader,
    DhTable,
    DhTableColumn,
  },
  setup() {
    const [rows, pagination, loading] = useRemoteList(products.list);

    const exportToCsv = useExportToCsv({
      filename: "products.csv",
      action: () =>
        rows.value.map(product => ({
          Name: product.name,
          Type: product.type,
        })),
    });

    return { rows, loading, exportToCsv };
  },
});
